/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { v4 } from 'uuid'

// Libraries
import Select from 'react-select'

// Components
import { Input, TextArea, Select as InputSelect } from 'components/elements'
import ButtonDefault from '../elements/ButtonDefault'
import ParseContent from './ParseContent'
import Loading from './Loading'

// Real names only: Capitalized, UPPERCASE, or lowercase words.
// Allows Dutch forms (Jan de Vries, Anne-Marie, 't Hart, IJssel) and rejects
// mixed-case or digit spam (BmTSbZLHwA, 1rDcel54As).
const NEWSLETTER_NAME_REGEX =
  /^\s*(?:'?(?:(?:IJ|[A-ZÀ-Ý])[a-zà-ÿ]+|[A-ZÀ-Ý]{1,}|[a-zà-ÿ]{1,}))(?:[ '\u2019\-]+'?(?:(?:IJ|[A-ZÀ-Ý])[a-zà-ÿ]+|[A-ZÀ-Ý]{1,}|[a-zà-ÿ]{1,}))*\s*$/

const StyledForm = styled.form`
  position: relative;
`

const ConfirmationMessage = styled(ParseContent)``

const Label = styled.label`
  display: block;
`

const Mandatory = styled.span`
  font-size: ${(props) => props.theme.font.size.xm};
  color: ${(props) => props.theme.color.face.contrast};
  margin-left: 5px;
`

const GravityForm = ({ className, id, defaultFields = {} }) => {
  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
              checkboxLabel
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }) => node.formId === id
  )[0]

  const [fields, setFields] = useState({})
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')
  const formRef = useRef(null)

  useEffect(() => {
    const tempForm = { ...form }

    // add submit button as a field if missing
    if (
      tempForm.formFields.filter((item) => item.type === 'submit').length === 0
    ) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    setForm({ ...form, ...tempForm })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault()
    if (status === 'processing') return

    const formEl = event.currentTarget

    // Newsletter (form 3) names: block bot strings like "BmTSbZLHwA" / "1rDcel54As"
    if (Number(id) === 3) {
      const nameInputs = formEl.querySelectorAll(
        'div[data-type="text"] input[type="text"]'
      )

      let nameOk = true
      nameInputs.forEach((el) => {
        el.setCustomValidity('')
        const val = (el.value || '').trim()
        if (val && !NEWSLETTER_NAME_REGEX.test(val)) {
          el.setCustomValidity('Vul een geldige naam in')
          nameOk = false
        }
      })
      if (!nameOk) {
        formEl.reportValidity()
        return
      }
    }

    // --- JS fallback: validate phone fields even if pattern is dropped by <Input> wrapper
    const PHONE_JS = /^\+?(?=(?:.*\d){7,})[0-9\s\-()]+$/
    const phoneInputs = formEl.querySelectorAll(
      'div[data-type="phone"] input[type="tel"]'
    )

    let phoneOk = true
    phoneInputs.forEach((el) => {
      el.setCustomValidity('')
      const val = (el.value || '').trim()
      if (val && !PHONE_JS.test(val)) {
        el.setCustomValidity('Ongeldig telefoonnummer')
        phoneOk = false
      }
    })
    if (!phoneOk) {
      formEl.reportValidity()
      return
    }

    // Run native validation (required/type/pattern) too
    if (!formEl.reportValidity()) return

    setStatus('processing')

    try {
      const formData = new FormData()

      for (const [key, value] of Object.entries(defaultFields)) {
        formData.append(key, value)
      }

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')
        setMessage(response.confirmation_message)
      } else {
        setStatus('error')
        console.log(response)
      }
    } catch (error) {
      setStatus('error')
      console.error(error)
    }
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      setFields({
        ...fields,
        [event.target.name]: value,
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    return <ConfirmationMessage content={message} />
  }

  if (form.formFields) {
    return (
      <StyledForm
        ref={formRef}
        id={`form_${gfForm.formId}`}
        className={className}
        method="post"
        onSubmit={handleOnSubmit}
      >
        {status === 'processing' && <Loading />}
        {form.formFields &&
          form.formFields.map((field, key) => {
            if (field.visibility === 'hidden') return null

            if (Array.isArray(field)) {
              return (
                <div key={key}>
                  {field.map((item, index) => (
                    <FormField
                      key={index}
                      formId={id}
                      field={item}
                      fields={fields}
                      onChange={handleFieldChange}
                    />
                  ))}
                </div>
              )
            }

            return (
              <div key={key} data-type={field.type}>
                <FormField
                  field={field}
                  formId={id}
                  fields={fields}
                  onChange={handleFieldChange}
                />
              </div>
            )
          })}
      </StyledForm>
    )
  }

  console.error('No gravity forms found with id', id)
  return false
}

const TextField = ({
  value,
  onChange,
  formId,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => {
  const isNewsletterName = Number(formId) === 3
  const patternStr = isNewsletterName
    ? NEWSLETTER_NAME_REGEX.source.replace(/^\^|\$$/g, '')
    : undefined

  return (
    <div className="form-group">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value || ''}
        onChange={(e) => {
          e.currentTarget.setCustomValidity('')
          onChange(e)
        }}
        type="text"
        id={`input_${id}`}
        className={`${type} ${cssClass ?? ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
        pattern={patternStr || undefined}
        title={isNewsletterName ? 'Vul een geldige naam in' : undefined}
        onBlur={
          isNewsletterName
            ? (e) => {
                const v = e.currentTarget.value.trim()
                if (v && !NEWSLETTER_NAME_REGEX.test(v)) {
                  e.currentTarget.setCustomValidity('Vul een geldige naam in')
                  e.currentTarget.reportValidity()
                }
              }
            : undefined
        }
        onInvalid={
          isNewsletterName
            ? (e) => {
                e.currentTarget.setCustomValidity('Vul een geldige naam in')
              }
            : undefined
        }
      />
    </div>
  )
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // sensible baseline

const EmailField = ({
  value,
  onChange,
  field: {
    id,
    type,
    label,
    labelPlacement,
    placeholder,
    isRequired,
    cssClass,
    inputMaskValue,
  },
  customEmailRegex = EMAIL_REGEX, // allow override from callers if needed
}) => {
  // HTML pattern wants the regex *without* the leading/trailing anchors.
  const patternStr =
    (inputMaskValue && inputMaskValue.trim()) ||
    customEmailRegex.source.replace(/^\^|\$$/g, '') // anchors implied in pattern

  return (
    <div className="form-group">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value || ''}
        onChange={(e) => {
          e.currentTarget.setCustomValidity('')
          onChange(e)
        }}
        type="email"
        id={`input_${id}`}
        className={`${type} ${cssClass ?? ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
        // Use our custom pattern when Gravity’s mask is empty
        pattern={patternStr || undefined} // guard against empty string
        title="Ongeldig e-mailadres"
        onInput={(e) => e.currentTarget.setCustomValidity('')}
        onInvalid={(e) => {
          e.currentTarget.setCustomValidity('Ongeldig e-mailadres')
        }}
      />
    </div>
  )
}

// + optional at start, at least 7 digits total, only digits/space/-/( ) allowed
const PHONE_REGEX = /^\+?(?=(?:.*\d){7,})[0-9\s\-()]+$/

const PhoneField = ({
  value,
  onChange,
  field: {
    id,
    type,
    label,
    labelPlacement,
    placeholder,
    isRequired,
    cssClass,
    inputMaskValue,
  },
  customPhoneRegex = PHONE_REGEX,
}) => {
  const patternStr =
    (inputMaskValue && inputMaskValue.trim()) ||
    customPhoneRegex.source.replace(/^\^|\$$/g, '')

  const BLUR_REGEX = /^\+?(?=(?:.*\d){7,})[0-9\s\-()]+$/

  return (
    <div className="form-group">
      {labelPlacement !== 'hidden_label' && (
        <Label htmlFor={`input_${id}`}>
          {label}
          {isRequired && <Mandatory>*</Mandatory>}
        </Label>
      )}
      <Input
        value={value || ''}
        onChange={(e) => {
          e.currentTarget.setCustomValidity('')
          onChange(e)
        }}
        type="tel"
        id={`input_${id}`}
        className={`${type} ${cssClass ?? ''}`}
        name={`input_${id}`}
        required={isRequired}
        placeholder={placeholder}
        pattern={patternStr || undefined} // guard against empty string
        title="Ongeldig telefoonnummer"
        inputMode="tel"
        autoComplete="tel"
        onBlur={(e) => {
          const v = e.currentTarget.value.trim()
          if (v && !BLUR_REGEX.test(v)) {
            e.currentTarget.setCustomValidity('Ongeldig telefoonnummer')
            e.currentTarget.reportValidity()
          }
        }}
        onInvalid={(e) => {
          e.currentTarget.setCustomValidity('Ongeldig telefoonnummer')
        }}
      />
    </div>
  )
}

const TextAreaField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <div className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <TextArea
      value={value || ''}
      onChange={(e) => {
        e.currentTarget.setCustomValidity('')
        onChange(e)
      }}
      id={`input_${id}`}
      className={`${type} ${cssClass ?? ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const CheckboxField = ({
  value,
  onChange,
  field: { id, type, cssClass, choices },
}) => {
  const list = JSON.parse(choices)

  return (
    <div className="form-group">
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <input
            checked={!!value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass ?? ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content"
          >
            {checkbox.text}
          </label>
        </div>
      ))}
    </div>
  )
}

const CheckboxFieldConsent = ({
  value,
  onChange,
  field: { id, type, cssClass, checkboxLabel },
}) => {
  return (
    <div className="form-group">
      <div className="form-group__checkboxes">
        <input
          checked={!!value}
          onChange={onChange}
          type="checkbox"
          id={`input_${id}`}
          className={`${type} ${cssClass ?? ''} mr-2`}
          name={`input_${id}`}
          value="t"
        />
        <label
          htmlFor={`input_${id}`}
          className="checkbox-content font-size-sm mb-0 mr-3"
        >
          {checkboxLabel}
        </label>
      </div>
    </div>
  )
}

const StyledSelect = styled(InputSelect)``

// Select or Dropdown
const SelectField = ({ field, onChange, value }) => {
  // Populate a options array
  const options = []
  JSON.parse(field.choices).forEach((choice) => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`,
    })
  })

  // Custom Select component
  const MySelect = (props) => (
    <Select
      {...props}
      classNamePrefix="select"
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <div className="form-group">
      <StyledSelect>
        <MySelect
          options={options}
          onChange={onChange}
          value={options.filter((option) => option.value === value)}
          placeholder={field.label}
          classNamePrefix="react-select"
        />
      </StyledSelect>
    </div>
  )
}

const SubmitButtonButton = styled.button`
  color: ${(props) => props.theme.color.text.light};

  &:hover {
    color: ${(props) => props.theme.color.text.secondary};
  }
`

const PrivacyPolicy = styled.div`
  & a {
    text-decoration: underline;
  }
`

const SubmitButton = ({ field, formId }) => (
  <>
    <PrivacyPolicy className="privacy d-flex align-items-center mb-3">
      <input
        type="checkbox"
        id={`input_accept_${formId}`}
        name={`input_accept_${formId}`}
        value="t"
        className="mr-2"
        required
      />
      <label
        htmlFor={`input_accept_${formId}`}
        className="checkbox-content font-size-sm mb-0 mr-3"
      >
        Ik accepteer de{' '}
        <a href="/privacyverklaring/" target="blank">
          voorwaarden
        </a>
      </label>
    </PrivacyPolicy>

    <div>
      <ButtonDefault isCustom>
        <SubmitButtonButton type="submit">{field.text}</SubmitButtonButton>
      </ButtonDefault>
    </div>
  </>
)

const FileField = ({
  value,
  onChange,
  field: { id, type, label, allowedExtensions, cssClass, placeholder },
}) => {
  function handleChange(file) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file,
      },
    })
  }

  function handleFileUpload(e) {
    const files = e.target.files
    for (let i = 0; i < files.length; i++) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <div
      className="form-upload mb-4"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <Label htmlFor={`input_${id}`}>{value ? value.name : <>{label}</>}</Label>
      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass ?? ''}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </div>
  )
}

export const FormField = ({ field, formId, fields, onChange }) => (
  <>
    {field.type === 'text' && (
      <TextField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
        formId={formId}
      />
    )}
    {field.type === 'email' && (
      <EmailField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'phone' && (
      <PhoneField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'textarea' && (
      <TextAreaField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'checkbox' && (
      <CheckboxField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'consent' && (
      <CheckboxFieldConsent
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'select' && (
      <SelectField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'fileupload' && (
      <FileField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'submit' && <SubmitButton formId={formId} field={field} />}
  </>
)

export default GravityForm
